import {
  Grid,
  List,
  ListItemText,
  Typography,
  ListItemButton,
  ListItemIcon,
  Box,
} from "@mui/material";
import React from "react";
import MainLaunchpad from "./Launchpad/MainLaunchpad";
import SliderLaunchpad from "./Launchpad/SliderLaunchpad";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import Footer from "../Screen/Home/Footer";
import NavBar from "./NavBar/NavBar";
import {
  BUILDYOUROWNVIKINGLEGEND,
  THEWITCHERWILDHUNT,
} from "../Constant/constant";
import FooterPage from "./FooterPage";
const Launchpad = () => {
  return (
    <Grid container sx={{ backgroundColor: "black", margin: 0 }}>
      <Grid item xs={0} sm={0} lg={2} md={2} xl={2}>
        <NavBar />
      </Grid>
      <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <SliderLaunchpad />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            sx={{ paddingLeft: "8%",paddingTop:'7%' }}
          >
            <Typography className="launchpad-header-text">{BUILDYOUROWNVIKINGLEGEND}</Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}sx={{paddingTop:'7%' }}>
            <item>
              <Typography className="launchpad-paragraph-text">Become Eivor, a Viking raider raised to be a fearless warrior, and lead your clan from icy desolation in Norway to a new home amid the lush farmlands of ninth-century England. Find your settlement and conquer this hostile land by any means to earn a place in Valhalla.</Typography>
            </item>
            <item>
                <ListItemButton>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flex: "100%",
                      alignItems: "center",
                    }}
                  >
                    <PlayCircleOutlineIcon sx={{ color: "#2f6df6" }} />
                    <Typography
                      sx={{
                        color: "#2f6df6",
                        fontFamily: "Roboto",
                        paddingLeft: "2%",
                      }}
                    >
                      {THEWITCHERWILDHUNT}
                    </Typography>
                  </Box>
                </ListItemButton>
            </item>
          </Grid>
          <Grid item lg={12} md={12} xl={12}>
            <MainLaunchpad />
          </Grid>
          <Grid item md={12} lg={12} xl={12}>
            <Footer />
          </Grid>
          <Grid item md={12} lg={12} xl={12}>
            <FooterPage />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Launchpad;
